import React from "react";
import { Link } from "react-router-dom";
import { WaveIcon, Sparkle } from "./Decorations";
import { Twitter, Facebook, Linkedin, Instagram } from "lucide-react";

const COLS = [
    {
        title: "Product",
        links: [
            { label: "Features", href: "/#features" },
            { label: "Pricing", href: "/pricing" },
            { label: "Voices", href: "/voices" },
            { label: "WordPress plugin", href: "/wordpress" },
            { label: "About", href: "/about" },
        ],
    },
    {
        title: "Company",
        links: [
            { label: "About", href: "/about" },
            { label: "WordPress", href: "/wordpress" },
            { label: "Voices", href: "/voices" },
            { label: "Pricing", href: "/pricing" },
            { label: "Contact", href: "mailto:contact@audo.dev" },
        ],
    },
    {
        title: "Resources",
        links: [
            { label: "Voice samples", href: "/voices" },
            { label: "WordPress guide", href: "/wordpress" },
            { label: "How it works", href: "/#how-it-works" },
            { label: "FAQ", href: "/#faq" },
            { label: "Support", href: "/support" },
        ],
    },
];

const SOCIALS = [
    { Icon: Facebook,  href: "https://facebook.com/audo.dev",           label: "Facebook" },
    { Icon: Instagram, href: "https://instagram.com/audo.dev",          label: "Instagram" },
    { Icon: Twitter,   href: "https://x.com/audo.dev",                  label: "X / Twitter" },
    { Icon: Linkedin,  href: "https://linkedin.com/company/audo.dev",   label: "LinkedIn" },
];

export const Footer = () => {
    return (
        <footer className="relative pt-20 lg:pt-28 pb-10 border-t border-cream-300 bg-cream-100 overflow-hidden">
            <div className="relative mx-auto max-w-[1240px] px-5 sm:px-8">
                <div className="grid grid-cols-2 lg:grid-cols-12 gap-y-12 gap-x-8">
                    <div className="col-span-2 lg:col-span-4">
                        <div className="flex items-center gap-2.5 mb-5">
                            <WaveIcon color="#FF5B3E" className="w-7 h-5"/>
                            <span className="font-display text-[26px] font-semibold tracking-tight text-ink">Audo</span>
                        </div>
                        <p className="text-[14px] text-ink-muted leading-relaxed max-w-xs">
                            Beautiful Bengali audio for every article. Built by Bengali engineers, for Bengali newsrooms.
                        </p>
                        <div className="mt-5 flex items-center gap-3">
                            {SOCIALS.map(({ Icon, href, label }) => (
                                <a key={label} href={href} target="_blank" rel="noopener noreferrer" className="w-9 h-9 rounded-full bg-white border border-cream-300 flex items-center justify-center hover:bg-ink hover:text-cream-100 transition-colors" aria-label={label}>
                                    <Icon size={15}/>
                                </a>
                            ))}
                        </div>
                    </div>
                    {COLS.map((col, i) => (
                        <div key={i} className="lg:col-span-2">
                            <h4 className="text-[11px] uppercase tracking-[0.22em] font-semibold text-ink-muted mb-4">{col.title}</h4>
                            <ul className="space-y-2.5">
                                {col.links.map((l, j) => (
                                    <li key={j}>
                                        {l.href.startsWith("mailto:") || l.href.startsWith("http") ? (
                                            <a href={l.href} className="text-[14px] text-ink hover:text-coral transition-colors">{l.label}</a>
                                        ) : (
                                            <Link to={l.href} className="text-[14px] text-ink hover:text-coral transition-colors">{l.label}</Link>
                                        )}
                                    </li>
                                ))}
                            </ul>
                        </div>
                    ))}
                    <div className="col-span-2 lg:col-span-2">
                        <h4 className="text-[11px] uppercase tracking-[0.22em] font-semibold text-ink-muted mb-4">Contact</h4>
                        <ul className="space-y-2.5 text-[14px] text-ink">
                            <li><a href="mailto:contact@audo.dev" className="hover:text-coral transition-colors">contact@audo.dev</a></li>
                            <li><a href="tel:+8801552494771" className="hover:text-coral transition-colors">+8801552494771</a></li>
                            <li className="text-ink-muted">Mohammadpur, Dhaka</li>
                        </ul>
                    </div>
                </div>

                {/* Big footer mark */}
                <div className="mt-20 mb-8 relative">
                    <p className="bn font-display text-center text-[36px] sm:text-[64px] lg:text-[112px] font-medium tracking-tight text-ink leading-[0.95]">
                        বাংলা সংবাদের <span className="italic-display text-coral">নতুন কণ্ঠ</span>
                    </p>
                    <Sparkle color="#FFD23F" className="absolute top-[10%] left-[12%] w-8 h-8 animate-float-slow"/>
                    <Sparkle color="#3D5BFF" className="absolute bottom-[10%] right-[14%] w-6 h-6 animate-float-fast"/>
                </div>

                <div className="flex flex-col sm:flex-row items-center justify-between gap-3 pt-7 border-t border-cream-300 text-[12px] text-ink-muted">
                    <span>© 2026 Audo. Made in Dhaka.</span>
                    <div className="flex items-center gap-5">
                        <Link to="/privacy" className="hover:text-ink transition-colors">Privacy</Link>
                        <Link to="/terms" className="hover:text-ink transition-colors">Terms</Link>
                        <Link to="/cookies" className="hover:text-ink transition-colors">Cookies</Link>
                    </div>
                </div>
            </div>
        </footer>
    );
};

